import { CardContent, Box, Grid, Typography, TextField, Button, MenuItem, Select, FormControl } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import GooglePlacesInput from "../../UpdateLocation";

const PersonalInformationCard = ({
  isEditModePersonalInformation,
  handleSaveClick,
  handleEditClickPersonalInfo,
  isAnyButtonInEditMode,
  errors,
  formData,
  handleChange,
  vendorTypes,
  handleAddressSelection,
  setFormData
}) => {
  return (
    <CardContent>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="h6">Personal Information</Typography>
        <Button
          startIcon={
            isEditModePersonalInformation
              ? <SaveIcon sx={{ color: Object.keys(errors).length > 0 ? 'grey' : '#1E40AF' }} />
              : <EditIcon sx={{ color: 'grey' }} />
          }
          size="small"
          sx={{
            borderRadius: 2,
            border: "1px solid #D3D3D3",
            backgroundColor: "transparent",
            color: isEditModePersonalInformation && Object.keys(errors).length === 0 ? '#1E40AF' : 'grey',
            "&:hover": {
              borderColor: "#1E40AF",
              color: "#1E40AF",
            },
          }}
          onClick={isEditModePersonalInformation ? handleSaveClick : handleEditClickPersonalInfo}
          disabled={(isAnyButtonInEditMode && !isEditModePersonalInformation) || Object.keys(errors).length > 0}
        >
          {isEditModePersonalInformation ? "Save" : "Edit"}
        </Button>
      </Box>

      <Grid container spacing={2}>
        {[
          { label: "Full Name", name: "full_name" },
          { label: "Business Name", name: "business_name" },
          { label: "Professional Title", name: "professional_title" },
          { label: "Phone Number", name: "phone_number" }
        ].map((field) => (
          <Grid item xs={12} sm={6} key={field.name}>
            <Typography variant="subtitle2" color="text.secondary">{field.label}:</Typography>
            {isEditModePersonalInformation ? (
              <>
                <TextField
                  fullWidth
                  name={field.name}
                  value={formData?.[field.name]}
                  onChange={(e) => {
                    if (field.name === "phone_number") {
                      const phoneNumber = e.target.value.replace(/[^0-9]/g, '');
                      handleChange({ target: { name: 'phone_number', value: phoneNumber } });
                    } else {
                      handleChange(e);
                    }
                  }}
                />
                {errors[field.name] && <Typography variant="body2" color="error" sx={{ mt: 1 }}>{errors[field.name]}</Typography>}
              </>
            ) : (
              <Typography variant="body1">{formData?.[field.name]}</Typography>
            )}
          </Grid>
        ))}

        <Grid item xs={12} sm={6}>
          <Typography variant="subtitle2" color="text.secondary">Email:</Typography>
          <Typography variant="body1">{formData?.email}</Typography>
        </Grid>

        <Grid item xs={12} sm={6}>
          {/* <Typography variant="subtitle2" color="text.secondary">Vendor Type:</Typography>
          {isEditModePersonalInformation ? (
            <FormControl fullWidth>
              <Select
                name="vendor_type"
                value={formData?.vendor_type || ""}
                onChange={handleChange}
              >
                {vendorTypes.map((type) => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          ) : (
            <Typography variant="body1">{formData?.vendor_type}</Typography>
          )} */}
          <Typography variant="subtitle2" color="text.secondary">Location:</Typography>
          {isEditModePersonalInformation ? (
            <GooglePlacesInput
              value={formData?.address}
              onChange={(newAddress) => setFormData({ ...formData, location: newAddress })}
              onAddressSelect={handleAddressSelection}
            />
          ) : (
            <Typography variant="body1">{formData?.address}</Typography>
          )}        
        </Grid>

        {/* <Grid item xs={12} sm={6}>
          <Typography variant="subtitle2" color="text.secondary">Location:</Typography>
          {isEditModePersonalInformation ? (
            <GooglePlacesInput
              value={formData?.address}
              onChange={(newAddress) => setFormData({ ...formData, location: newAddress })}
              onAddressSelect={handleAddressSelection}
            />
          ) : (
            <Typography variant="body1">{formData?.address}</Typography>
          )}
        </Grid> */}
      </Grid>
    </CardContent>
  );
};

export default PersonalInformationCard;
